// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__3up1b","ant-page-header-heading-title":"styles_ant-page-header-heading-title__BUCFo","table":"styles_table__otRut"};